import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import EmailField from "src/commun/composants/formulaire/fields/EmailField";
import { useFormikContext } from "formik";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import AppRow from "src/commun/composants/grille/AppRow";
import AppPopin from "src/commun/composants/AppPopin/AppPopin";
import ConfirmationPopin from "src/commun/composants/ConfirmationPopIn/ConfirmationPopin";
import { AppRoutes } from "src/routes/AppRoutes";
import { useNavigate } from "react-router-dom";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import { checkEmail } from "src/app/api/PublicApi";
import { AxiosError } from "axios";
import { UserToFinalize } from "src/domain/UserToFinalize";

export type CodeMailSendFormContentProps = {
  allowRattachement?: boolean;
  setCustomError: (err: AxiosError) => void;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
  userToFinalize?: UserToFinalize;
};

const CodeMailSendFormContent = ({ allowRattachement, userToFinalize, setCustomError, displayCancelBtn, cancelCallback }: CodeMailSendFormContentProps) => {
  const { tString } = useAppText();
  const { submitForm, values } = useFormikContext<VerificationMail>();
  const navigate = useNavigate();
  const [popinRattachement, setPopinRattachement] = useState(false);
  const [displayWarnEmail, setDisplayWarnEmail] = useState(false);

  const handleSubmitForm = () => {
    if (!allowRattachement) {
      submitForm();
    } else {
      checkEmail(values.email).then(res => {
        if (res.uid) {
          //Email deja existant, on propose le rattachement
          setPopinRattachement(true);
        } else {
          submitForm();
        }
      })
      .catch(err => {
        setCustomError(err);
      });
    }
  }


  return (
    <>
      {displayWarnEmail &&
        <AppMessage messageType="WARNING" children={<>{tString("migration.warning.choixAutreMail")}</>} />}

      <div className="input">
        <EmailField />
        <label>{tString("creation.step.1.label")}</label>
      </div>

      <AppRow>
        {displayCancelBtn &&
          <input
            className="btn__primary mt-3 mr-3 btn--full--xs"
            type="submit"
            name="annuler"
            onClick={cancelCallback}
            value={tString("update.email.cancel.button")}
          />
        }
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={handleSubmitForm}
          value={tString("action.recevoir.code.validation")}
        />
      </AppRow>

      <AppPopin
        opened={popinRattachement}
        onModalClick={() => setPopinRattachement(false)}
      >
        <ConfirmationPopin
          text="migration.step.1.attach.question"
          validerLabel="action.attach.yes"
          validerHandler={() => {
            navigate(AppRoutes.RATTACHEMENT_PATH.getPath() + "?sourceUid="+ userToFinalize?.userId +"&targetEmailAddress="+ values.email);
          }}
          annulerLabel="global.annuler"
          annulerHandler={() => {
            setDisplayWarnEmail(true);
            setPopinRattachement(false);
          }}
        />
      </AppPopin>
    </>
  );
};

export default CodeMailSendFormContent;